import React from 'react'
import {Col} from '@modifi/ui'
import {
  FormInputWrapper,
  useInputIsVisible,
  FormDataFilter as FormFilter,
} from '@modifi/plugin-onboarding'

import {ColSizeProps, FormDataFilterFunc, InputOption, TranslateFn} from '../../../../types/common'

type FormInputComponentColProps = {
  inputName: string
  filterFunc?: FormDataFilterFunc | null
  filterParams?: Record<string, unknown>
  inputComponent: React.ElementType
  t: TranslateFn
  isValid?: boolean
  options?: InputOption[]
  inputProps?: Record<string, unknown>
  errorMessage?: string | null
  colProps?: ColSizeProps
  isAlwaysVisible?: boolean
}

const FormInputComponentCol: React.FC<FormInputComponentColProps> = ({
  inputName,
  filterFunc = null,
  filterParams = {},
  inputComponent,
  t,
  colProps,
  inputProps = {},
  isAlwaysVisible = false,
  ...restProps
}) => {
  const isInputVisible = useInputIsVisible(inputName)

  const FormDataFilter = filterFunc ? FormFilter : React.Fragment

  const filterObj = filterFunc ? {filterFunc, filterParams} : {}

  if (!isInputVisible && !isAlwaysVisible) {
    return null
  }
  return (
    <>
      {/*
     // @ts-expect-error filterFunc prop wont be undefined since there is a null check above   */}
      <FormDataFilter {...filterObj}>
        <Col
          col={colProps?.col || 12}
          md={colProps?.md || 6}
          lg={colProps?.lg || colProps?.md || 6}
        >
          <FormInputWrapper
            name={inputName}
            inputComponent={inputComponent}
            t={t}
            hideTooltip
            {...inputProps}
            {...restProps}
          />
        </Col>
      </FormDataFilter>
    </>
  )
}

export default FormInputComponentCol
